import axios from "axios";
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'http://128.199.3.198/backend',
  headers: {
    "Content-type": "application/json",
  },
});

export const makeApiCall = async (url, method, data, params) => {
  const token = localStorage.getItem("x-access-token");

  const headers = {
    "Content-type": "application/json",
    "x-access-token": token,
  };

  try {
    const response = await apiClient({
      method,
      url,
      data,
      params,
      headers,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
